module.exports = __webpack_public_path__ + "assets/images/animations/medipremium-animation.webp?7f1ff4bb";